module.exports = __webpack_public_path__ + "static/30-da9d2018f71b1a2b7cc2a433be6ff509.png";